<template>
  <div class="companylist">
    <el-tabs v-model="activeName"
             @tab-click="handleClick"
             class="tabs">
      <el-tab-pane label="物流公司"
                   name="1"></el-tab-pane>
      <el-tab-pane label="货主公司"
                   name="0"></el-tab-pane>
    </el-tabs>

    <el-form :inline="true"
             :model="formInline"
             class="companylist-search"
             label-position="right">
      <el-form-item label="公司名称"
                    size="small">
        <el-input v-model="formInline.companyName"
                  placeholder="请输入公司名称"></el-input>
      </el-form-item>
      <el-form-item label="联系人姓名"
                    size="small">
        <el-input v-model="formInline.contacts"
                  placeholder="请输入联系人姓名"></el-input>
      </el-form-item>
      <el-form-item class="btn_box">
        <el-button type="primary"
                   size="small"
                   class="searchBtn"
                   @click="handleSearchClick">查询</el-button>
        <router-link to="companylist/addCompany">
          <el-button type="warning"
                     class="addBtn"
                     size="small">添加</el-button>
        </router-link>
      </el-form-item>
    </el-form>

    <div class="companylist-container"
         v-if="activeName === '0'">
      <!-- 货主公司 -->
      <el-table :data="logisticsData.result"
                height='100%'>
        <el-table-column class-name="number"
                         label="序号"
                         align="center"
                         type="index"
                         min-width="40">
        </el-table-column>
        <el-table-column class-name="companyName"
                         prop="companyName"
                         label="公司名称">
        </el-table-column>
        <el-table-column label="邀请码">
          <template slot-scope="scope">
            <div>{{scope.row.inviteCode}}</div>
          </template>
        </el-table-column>

        <el-table-column label="公司信息">
          <template slot-scope="scope">
            <div><span>联系人姓名：</span>{{scope.row.linkman}}</div>
            <div><span>联系电话：</span>{{scope.row.phone}}</div>
            <div><span>传真：</span>{{scope.row.fax}}</div>
            <div><span>公司地址：</span>{{scope.row.region}}{{scope.row.address}}</div>
            <!-- <div v-if="scope.row.performanceBond ==='0'"><span>保证金：</span>未缴纳</div>
            <div v-if="scope.row.performanceBond ==='1'"><span>保证金：</span>5万</div>
            <div v-if="scope.row.performanceBond ==='2'"><span>保证金：</span>10万</div>
            <div v-if="scope.row.performanceBond ==='3'"><span>保证金：</span>15万</div>
            <div v-if="scope.row.performanceBond ==='4'"><span>保证金：</span>20万</div>
            <div v-if="scope.row.performanceBond ==='5'"><span>保证金：</span>25万</div> -->
            <div><span>公司产品：</span>{{scope.row.companyProducts}}</div>
          </template>
        </el-table-column>
        <el-table-column class-name="qualifiedInfo"
                         label="资质信息"
                         header-align="center"
                         align="left"
                         width="185">
          <template slot-scope="scope">
            <!-- {{scope.row.qualifiedInfo.businessLicense}} -->
            <div class="qualifiedList">
              <span>营业执照：</span><img :src="scope.row.businessLicense.imgUrl"
                   @click="handleShowImgClick(scope.row.businessLicense.imgUrl)"
                   alt="营业执照">
            </div>
            <div class="qualifiedList">
              <span>危险品经营许可证：</span><img :src="scope.row.dangerGoodsLicense.imgUrl"
                   @click="handleShowImgClick(scope.row.dangerGoodsLicense.imgUrl)"
                   alt="危险品经营许可证">
            </div>
            <div class="qualifiedList">
              <span>开户许可证：</span><img :src="scope.row.bankAccountLicense.imgUrl"
                   @click="handleShowImgClick(scope.row.bankAccountLicense.imgUrl)"
                   alt="">
            </div>
            <div class="qualifiedList">
              <span>开票信息：</span><img :src="scope.row.ticketPost.imgUrl"
                   @click="handleShowImgClick(scope.row.ticketPost.imgUrl)"
                   alt="">
            </div>
          </template>
        </el-table-column>

        <el-table-column label="公司认证"
                         header-align="center"
                         align="center"
                         min-width="67">
          <template slot-scope="scope">
            <div v-if="scope.row.status ==='0'"
                 class="status-style wait">待审核</div>
            <div v-if="scope.row.status ==='1'"
                 class="status-style pass"><span>审核</span><span>通过</span></div>
            <div v-if="scope.row.status ==='2'"
                 class="status-style fail">不通过</div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         label="操作"
                         width="128"
                         align="center"
                         class-name="operation">
          <template slot-scope="scope">
            <el-button @click="handleOwnerClick(scope.row.companyId)">
              公司审核
            </el-button>

            <el-button v-if="scope.row.auditStatus === '0'"
                       @click="handleAuthorizationClick(scope.row.companyId)">
              授权审核
            </el-button>
            <el-button v-else-if="scope.row.auditStatus !== '0'"
                       disabled>
              授权审核
            </el-button>
            <el-button @click="handleUpdateClick(scope.row.companyId)">
              修改
            </el-button>
          </template>

        </el-table-column>

      </el-table>

      <!-- 货主公司 -->
      <el-dialog title="信息审核"
                 :visible.sync="showOwnerDetails"
                 class="biddingTable"
                 trigger="click">
        <div class="auditList">
          <div class="auditStyle">审核：</div>
          <el-radio v-model="owner.audit.status"
                    label="1">审核通过</el-radio>
          <el-radio v-model="owner.audit.status"
                    label="2">审核未通过</el-radio>
        </div>
        <div class="auditList">
          <div class="auditStyle">公司产品：</div>
          <el-input :disabled="owner.audit.status==='2'?true:false"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 8}"
                    v-model="owner.remarks"
                    placeholder="请输入公司经营的主要产品,以逗号（ ，）隔开"></el-input>
        </div>
        <el-button class="auditConfirm"
                   @click="handleOwnerConfirmClick">确定</el-button>
      </el-dialog>
      <!-- 分页 -->
    </div>
    <div class="companylist-container"
         v-if="activeName==='1'">
      <!-- 物流公司 -->
      <el-table :data="logisticsData.result"
                height='100%'>
        <el-table-column class-name="number"
                         label="序号"
                         align="center"
                         type="index"
                         min-width="40">
        </el-table-column>
        <el-table-column class-name="companyName"
                         prop="companyName"
                         label="公司名称">
        </el-table-column>
        <el-table-column label="物流信息">
          <template slot-scope="scope">
            <div><span>好评率：</span>{{scope.row.praise}}%</div>
            <div><span>行驶里程：</span>{{scope.row.totalMileage}}公里</div>
            <div><span>司机数量：</span>{{scope.row.driverCount}}个</div>
            <div><span>货车数量：</span>{{scope.row.truckCount}}辆</div>
          </template>
        </el-table-column>
        <el-table-column label="公司信息">
          <template slot-scope="scope">
            <div><span>联系人姓名：</span>{{scope.row.linkman}}</div>
            <div><span>联系电话：</span>{{scope.row.phone}}</div>
            <div><span>传真：</span>{{scope.row.fax}}</div>
            <div><span>公司地址：</span>{{scope.row.region}}{{scope.row.address}}</div>
            <div v-if="scope.row.performanceBond ==='0'"><span>保证金：</span>未缴纳</div>
            <div v-if="scope.row.performanceBond ==='1'"><span>保证金：</span>5万</div>
            <div v-if="scope.row.performanceBond ==='2'"><span>保证金：</span>10万</div>
            <div v-if="scope.row.performanceBond ==='3'"><span>保证金：</span>15万</div>
            <div v-if="scope.row.performanceBond ==='4'"><span>保证金：</span>20万</div>
            <div v-if="scope.row.performanceBond ==='5'"><span>保证金：</span>25万</div>
            <div><span>公司类别：</span>{{scope.row.safeType}}</div>
            <div v-if="scope.row.roleType==='0'"><span>角色类型：</span>物流公司</div>
            <div v-else-if="scope.row.roleType==='1'"><span>角色类型：</span>个人车主</div>
            <div v-else-if="scope.row.roleType==='3'"><span>角色类型：</span>物流中介</div>
          </template>
        </el-table-column>
        <el-table-column class-name="qualifiedInfo"
                         label="资质信息"
                         header-align="center"
                         align="left"
                         width="185">
          <template slot-scope="scope">
            <!-- {{scope.row.qualifiedInfo.businessLicense}} -->
            <div class="qualifiedList"><span>营业执照：</span><img :src="scope.row.businessLicense.imgUrl"
                   @click="handleShowImgClick(scope.row.businessLicense.imgUrl)"
                   alt="营业执照"></div>
            <div class="qualifiedList"><span>危险品经营许可证：</span><img :src="scope.row.dangerGoodsLicense.imgUrl"
                   @click="handleShowImgClick(scope.row.dangerGoodsLicense.imgUrl)"
                   alt="危险品经营许可证"></div>
            <div class="qualifiedList"><span>开户许可证：</span><img :src="scope.row.bankAccountLicense.imgUrl"
                   @click="handleShowImgClick(scope.row.bankAccountLicense.imgUrl)"
                   alt=""></div>

            <div class="qualifiedList"><span>开票信息：</span><img :src="scope.row.ticketPost.imgUrl"
                   @click="handleShowImgClick(scope.row.ticketPost.imgUrl)"
                   alt=""></div>
          </template>
        </el-table-column>

        <el-table-column label="公司认证"
                         header-align="center"
                         align="center"
                         min-width="67">
          <template slot-scope="scope">
            <div v-if="scope.row.status ==='0'"
                 class="status-style wait">待审核</div>
            <div v-if="scope.row.status ==='1'"
                 class="status-style pass"><span>审核</span><span>通过</span></div>
            <div v-if="scope.row.status ==='2'"
                 class="status-style fail">不通过</div>
          </template>
        </el-table-column>
        <el-table-column label="保证金"
                         header-align="center"
                         align="center"
                         min-width="67">
          <template slot-scope="scope">
            <div v-if="scope.row.hasBond ===0">未缴纳 </div>
            <div v-if="scope.row.hasBond ===1">待审核</div>
            <div v-if="scope.row.hasBond ===2">已缴纳</div>
            <div v-if="scope.row.hasBond ===3">申请退款 </div>
            <div v-if="scope.row.hasBond ===4">退款成功 </div>
          </template>
        </el-table-column>

        <el-table-column header-align="center"
                         label="操作"
                         width="128"
                         align="center"
                         class-name="operation">
          <template slot-scope="scope">
            <el-button @click="handleLogAuditClick(scope.row)">
              审核
            </el-button>
            <el-button v-if="scope.row.hasBond ===0"
                       @click="handleAuditEarnestClick(scope.row.companyId)">
              审核保证金
            </el-button>
            <el-button v-if="scope.row.hasBond ===4"
                       @click="handleAuditEarnestClick(scope.row.companyId)">
              已退款
            </el-button>
            <el-button v-if="scope.row.hasBond ===2"
                       @click="handleRefundClick(scope.row.companyId)">
              退款
            </el-button>

            <el-button v-if="scope.row.hasBond ===1"
                       @click="handleAuditEarnestClick(scope.row.companyId)">
              审核保证金
            </el-button>
            <el-button @click="handleUpdateClick(scope.row.companyId)">
              修改
            </el-button>
            <el-button @click="hanleOperationClick(scope.row.companyId)">
              运营路线
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 物流公司 -->
      <el-dialog title="信息审核"
                 :visible.sync="showDetails"
                 class="biddingTable"
                 trigger="click">
        <div class="auditList">
          <div class="auditStyle">审核：</div>
          <el-radio v-model="audit.status"
                    label="1">审核通过</el-radio>
          <el-radio v-model="audit.status"
                    label="2">审核未通过</el-radio>
        </div>
        <div class="auditList">
          <div class="auditStyle">角色分类：</div>
          <el-radio :disabled="audit.status==='2'?true:false"
                    v-model="audit.roleType"
                    label="0">物流公司</el-radio>
          <el-radio :disabled="audit.status==='2'?true:false"
                    v-model="audit.roleType"
                    label="1">个人车主</el-radio>
          <el-radio :disabled="audit.status==='2'?true:false"
                    v-model="audit.roleType"
                    label="3">物流中介</el-radio>
        </div>
        <div class="auditList">
          <div class="auditStyle">公司类别：<span>(多选)</span></div>
          <el-checkbox-group class="appnameStyle"
                             v-model="checkboxGroup2"
                             size="medium">
            <el-checkbox-button :disabled="audit.status==='2'?true:false"
                                v-for="(item,index) in appOptions"
                                :label="item"
                                :key="index">
              <p v-if="item === '一类'">一类</p>
              <p v-else-if="item === '二类'">二类</p>
              <p v-else-if="item === '三类'">三类</p>
              <p v-else-if="item === '四类'">四类</p>
              <p v-else-if="item === '五类'">五类</p>
              <p v-else-if="item === '六类'">六类</p>
              <p v-else-if="item === '七类'">七类</p>
              <p v-else-if="item === '八类'">八类</p>
              <p v-else-if="item === '九类'">九类</p>
            </el-checkbox-button>
          </el-checkbox-group>
        </div>
        <el-button class="auditConfirm"
                   @click="handleAuditConfirmClick">确定</el-button>
      </el-dialog>

    </div>
    <div class='imgDetail'>
      <el-dialog title="资质信息详情"
                 :visible.sync="showImg">
        <el-carousel trigger="click"
                     arrow="always"
                     indicator-position='none'
                     :autoplay="false">
          <el-carousel-item v-for="(item,index) in imgList"
                            :key="index">
            <div class="imgMain">
              <img :src=item
                   alt="">
            </div>
            <div class="imgNums">{{index+1}}/{{imgList.length}}</div>
          </el-carousel-item>
        </el-carousel>
      </el-dialog>
    </div>
    <div class="pages">
      <span class="demonstartion"> 共{{logisticsData.total}}条记录</span>
      <el-pagination @current-change='handleCurrentChange'
                     :page-size="logisticsData.pageSize"
                     layout="prev, pager, next"
                     :total="logisticsData.total"
                     background>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { companyList, auditCompany } from 'apis/index'
export default {
  name: 'Container',
  data () {
    return {
      activeName: '1',
      userPermissionTable: false,
      input: '',
      formInline: {
        companyName: '',
        contacts: ''
      },
      audit: {
        status: '',
        roleType: ''
      },
      logisticsData: [],
      imgList: [],
      showImg: false,
      showDetails: false,
      appOptions: ['一类', '二类', '三类', '四类', '五类', '六类', '七类', '八类', '九类'],
      checkboxGroup2: [],
      companyId: '',
      showOwnerDetails: false,
      owner: {
        remarks: '',
        audit: {
          status: '',
          roleType: ''
        }
      }
    }
  },
  methods: {
    handleClick (tab, event) { // 切换物流/货主公司
      this.$router.push({
        path: 'companylist',
        query: {
          item: tab.name
        }
      })
      this.getCompanyList(this.activeName)
    },

    handleSearchClick () { // 查询
      companyList({
        companyType: this.activeName,
        companyName: this.formInline.companyName,
        linkman: this.formInline.contacts
      }).then(res => {
        if (res.data.code === 0) {
          this.logisticsData = res.data.data.companyList
        }
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    getCompanyList (type) { // 获取物流公司/货主公司信息
      // console.log('aaaaaa', type)
      this.logisticsData = []
      companyList({
        companyType: type
      }).then(res => {
        if (res.data.code === 0) {
          // console.log('dsads', res)
          this.logisticsData = res.data.data.companyList
          // console.log('ss', res)
        }
      })
    },
    handleLogAuditClick (item) { // 显示物流审核
      console.log('item', item)
      companyList({
        companyType: item.companyType,
        companyName: item.companyName
      }).then(res => {
        console.log(res)
        if (res.data.code === 0) {
          this.showDetails = true
          let data = res.data.data.companyList.result[0]
          if (data.safeType) {
            this.checkboxGroup2 = data.safeType.split(',')
          }
          this.audit.roleType = data.roleType
          this.audit.status = data.status
          this.companyId = data.companyId
        }
      })
      // this.companyId = id
      // this.showDetails = true
    },
    handleAuditConfirmClick () { // 物流公司审核
      console.log('aaaid', this.companyId)
      let appname = ''
      this.checkboxGroup2.forEach(element => {
        appname += element + ','
      })
      appname = appname.substring(0, appname.length - 1)
      if (this.audit.status === '2') { // 审核未通过
        auditCompany({
          companyId: this.companyId,
          status: this.audit.status
        }).then(res => {
          if (res.data.code === 0) {
            this.getCompanyList(this.activeName)
            this.showDetails = false
          }
        })
      } else if (this.audit.status === '1') {
        auditCompany({
          companyId: this.companyId,
          status: this.audit.status,
          roleType: this.audit.roleType,
          safeType: appname
        }).then(res => {
          if (res.data.code === 0) {
            this.getCompanyList(this.activeName)
            this.showDetails = false
          }
        })
      }
    },
    handleAuditEarnestClick (id) { // 物流公司审核保证金
      console.log(id)
      this.$router.push({ path: 'companylist/auditEarnest', query: { id: id } })
    },
    handleRefundClick (id) { // 物流公司保证金退款
      this.$router.push({ path: 'companylist/auditEarnest', query: { refundID: id } })
    },
    handleOwnerClick (id) { // 货主公司审核
      this.owner.remarks = ''
      this.companyId = id
      this.showOwnerDetails = true
    },
    handleOwnerConfirmClick () {
      if (this.owner.audit.status === '1') { // 货主公司审核通过
        auditCompany({
          companyId: this.companyId,
          status: this.owner.audit.status,
          companyProducts: this.owner.remarks
        }).then(res => {
          this.getCompanyList(this.activeName)
          this.showOwnerDetails = false
        })
      } else if (this.owner.audit.status === '2') { // 货主公司审核不通过
        auditCompany({
          companyId: this.companyId,
          status: this.owner.audit.status
        }).then(res => {
          this.getCompanyList(this.activeName)
          this.showOwnerDetails = false
        })
      }
    },

    downloadIamge (imgsrc, name) { // 下载图片地址和图片名
      var image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function () {
        var canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        var context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        var url = canvas.toDataURL('image/png') // 得到图片的base64编码数据

        var a = document.createElement('a') // 生成一个a元素
        var event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc
    },
    handleShowImgClick (item) { // 下载图片
      console.log(item)
      this.imgList = []
      this.imgList.push(item)
      this.showImg = true
      // this.downloadIamge(item + '?imageView2/0/w/1000', '资质信息')
    },
    hanleOperationClick (id) { // 物流公司运营路线
      this.$router.push({ path: 'companylist/operation', query: { item: id } })
    },
    handleUpdateClick (id) { // 修改
      this.$router.push({ path: 'companylist/addCompany', query: { item: id } })
    },
    handleAuthorizationClick (id) { // 授权审核
      this.$router.push({ path: 'companylist/authorizationAudit', query: { item: id } })
    },
    handleCurrentChange (val) { // 切页切换
      let pageNum = val
      companyList({
        companyType: this.activeName,
        pageNum: pageNum
      }).then(res => {
        if (res.data.code === 0) {
          // console.log('dsads', res)
          this.logisticsData = res.data.data.companyList
          // console.log('ss', res)
        }
      })
    }

  },
  mounted () {
    this.activeName = this.$route.query.item ? this.$route.query.item : '1'
    this.getCompanyList(this.activeName)
  }
}
</script>

<style lang="stylus">
@import '~styles/mixins.styl'
.companylist
  height 100%
  .tabs
    height 51px
    overflow hidden
    background #fff
    .el-tabs__nav-wrap::after
      height 1px
      bottom 1px
    .el-tabs__item
      padding 0
      text-align center
      height 51px
      line-height 50px
      width 92px
      size12()
      color #5e656f
    .el-tabs__item.is-active
      border-bottom 2px solid #409EFF
      color #1b88ee
    .el-tabs__active-bar
      background transparent !important
  .companylist-search
    padding-left 20px
    padding-top 10px
    padding-right 20px
    .el-input
      width 146px
    .el-form-item
      margin-bottom 10px
    .btn_box
      float right
      .el-form-item__content
        line-height 30px
        .el-button
          margin-left 20px
        .searchBtn
          searchBtn()
        .addBtn
          addBtn()
  .companylist-container
    margin-left 20px
    margin-top 10px
    margin-right 20px
    height calc(100% - 160px)
    .el-table
      th
        background #e7f0f8
        .cell
          size12()
      td
        div
          size12()
      .qualifiedInfo
        .qualifiedList
          margin-top 3px
          overflow hidden
          position relative
          cursor pointer
          span
            float left
            width 78px
            text-align right
          img
            width 80px
            height 48px
            margin-left 3px
            float left
          .download
            position absolute
            bottom 5px
            right 8px
            width 12px
            height 13px
            background url('../../assets/images/05/down_n_icon.png') no-repeat center center
          &:hover .download
            background url('../../assets/images/05/down_h_icon.png') no-repeat center center
    .status-style
      width 40px
      height 40px
      border-radius 50%
      margin 0 auto
      border 1px solid transparent
      size10()
      line-height 40px
      text-align center
    .wait
      background #ffffff
      color #1B88EE
      border 1px solid #CFD5DC
    .pass
      background #00D5B9
      color #fff
      padding-top 5px
      span
        display block
        width 40px
        height 15px
        line-height 15px
    .fail
      background #CFD5DC
      color #fff
    .el-button
      size12()
      margin-bottom 10px
    .el-button:nth-child(1)
      margin-left 10px
      margin-top 0
    .operation
      .el-button
        size12()
        margin-bottom 10px
        margin-left 10px
        width 78px
        height 28px
        padding 0
        &:nth-child(1)
          background #1B88EE
          color #ffffff
        &:nth-child(2)
          background #1B88EE
          color #ffffff
        &:nth-child(3)
          border 1px solid #1B88EE
          background #fff
          color #1B88EE
        &:nth-child(4)
          border 1px solid #00D5B9
          background #00D5B9
          color #fff
    .biddingTable
      .el-dialog
        width auto
        width 728px
        .el-dialog__header
          height 42px
          padding 0 20px 0
          background #1b88ee
          .el-dialog__title
            line-height 42px
            font-size 13px
            color #fff
            float left
          .el-dialog__headerbtn
            top 12px
            right 12px
            .el-dialog__close
              color #fff
              font-size 20px
        .el-dialog__body
          padding 15px 20px
          .auditList
            margin-top 30px
            margin-left 68px
            .auditStyle
              margin-right 5px
              text-align right
              width 70px
              float left
              span
                color #858C96
                font-size 12px
                display block
                text-align center
            .el-textarea
              width 475px
              margin-left 12px
            .appnameStyle
              width 500px
              display inline-block
              span
                color #212832
                border 1px solid #CFD5DC
                border-radius 3px
                padding 6px 24px
              label
                width auto
                margin-right 21px
                margin-bottom 14px
                &:nth-child(4)
                  margin-right 30px
              .el-checkbox-button.is-checked .el-checkbox-button__inner
                box-shadow none
                border-color #409EFF
                background url('../../assets/images/05/xuanzhong.png') no-repeat right bottom
              .el-checkbox-button__inner:hover
                color #409EFF
                border-color #409EFF
          .auditConfirm
            margin 50px 300px
            padding 7px 43px
            background #1B88EE
            color #fff
  .imgDetail
    .el-dialog
      width 90vw !important
      height 90% !important
      margin-top 2vw !important
      .el-dialog__header
        height 42px
        padding 0 20px 0
        text-align left
        background #1b88ee
        line-height 42px
        .el-dialog__title
          font-size 13px
          color #fff
      .el-dialog__headerbtn
        top 12px
        right 12px
        .el-dialog__close
          color #fff
          font-size 20px
      .el-dialog__body
        height calc(100% - 62px)
        padding 12px
        .el-carousel
          width 100%
          height 100%
          .el-carousel__container
            width 100%
            // background #f66
            height 100% !important
            margin 0 auto
          .el-carousel__arrow--left
            left 0px
            width 21px
            height 38px
            background none
            // background url('../../assets/images/02/left_n_page.png') no-repeat
            // &:hover
            // background url('../../assets/images/02/left_h_page.png') no-repeat
          .el-icon-arrow-right:before
            content '' !important
          .el-carousel__arrow--right
            right 0px
            width 21px
            height 38px
            background none
            // background url('../../assets/images/02/righe_n_page.png') no-repeat
            // &:hover
            // background url('../../assets/images/02/right_h_page.png') no-repeat
          .el-icon-arrow-left:before
            content '' !important
          .imgMain
            width 100%
            height 100%
            // background #0f0
            position relative
            // top 50%
            // left 50%
            // transform translate(-50%,-50%)
            img
              height 100%
              position absolute
              top 50%
              left 50%
              transform translate(-50%, -50%)
          .imgNums
            position absolute
            bottom 10px
            left 50%
            transform translatex(-50%)
.pages
  padding 5px 15px
  .demonstartion
    float right
    line-height 45px
    color #5e656f
.el-table td, .el-table th
  vertical-align top
</style>
